import React from 'react';

import { makeMuiStyles } from '@styles';

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.flexInline,
    alignItems: 'center',
    color: theme.palette.grey['700'],
  },
  split: {
    height: 1,
    backgroundColor: theme.palette.grey['700'],
    flex: 1,
  },
  title: {
    ...common.bigText,
    fontWeight: 500,
    padding: '0 1.5rem',
  },
}));

export interface SplitProps {
  title: string;
}

export const Split: React.FC<SplitProps> = (props) => {
  const classes = useStyles();

  const { title } = props;

  return (
    <div className={classes.container}>
      <div className={classes.split} />
      <span className={classes.title}>{title}</span>
      <div className={classes.split} />
    </div>
  );
};
